export default {
	GET_TASK_DESCRIPTION: [
		{
			method: 'PATCH',
			url: 'Tasks/{taskId}',
			path: 'TaskDetail',
			updateEntity: 'description'
		}
	],
	GET_DOCUMENT_LIST: [
		{
			method: 'POST',
			url: 'TaskDocuments',
			updateEntity: 'data',
			filterEntity: 'filteredEntityIdGuid'
		}
	],
	ASSOCIATE_TASK_DOCUMENTS: [
		{
			method: 'POST',
			url: 'TaskDocuments',
			filterEntity: 'TaskId'
		}
	],
	GET_TASK_DETAILS: [
		{
			method: 'PATCH',
			url: 'Tasks/{taskId}',
			path: 'TaskNamePrefix',
			updateEntity: 'taskNameSuffix'
		},
		{
			method: 'PATCH',
			url: 'Tasks/{taskId}',
			path: 'TaskNameSuffix',
			updateEntity: 'taskNamePrefix'
		},
		{
			method: 'PATCH',
			url: 'Tasks/{taskId}',
			path: 'TaskDetail',
			updateEntity: 'description'
		}
	],
	UPDATE_DOCUMENT: [
		{
			method: 'PATCH',
			url: 'Documents/{documentId}',
			updateEntity: 'documentChangeTypeId'
		}
	]
};
